import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the FormatDurationShortPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'formatDurationShort',
})
export class FormatDurationShortPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, ...args) {
    let newString = value;
    if (/mins/.test(value) || /hours/.test(value)) {
      newString = newString.replace(/ mins/i, 'm');
      newString = newString.replace(/ hours/i, 'h');
    }
    return newString;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/format-duration-short/format-duration-short.ts